import {connect} from 'react-redux';
import Step15 from './Step15';
import {submitStep} from '../../actions/submitStep';
import {uploadFile} from '../../actions/uploadFile';
import {showGlobalErrorMessage} from '../../actions/globalErrorMessage/showGlobalErrorMessage';

const mapStateToProps = ({
                           regType: {regType}
                         }) => ({
  regType
});

export default connect(
  mapStateToProps,
  {submitStep, uploadFile, showGlobalErrorMessage}
)(Step15);
